import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { WorkoutInfoForm } from './views/WorkoutInfoForm';
import {
  EditWorkoutVM,
  useEditWorkoutVM,
  UseEditWorkoutVMParams,
} from './view-models/workoutEdit.viewModel';
import { TemplateSelection } from './components/TemplateSelection';
import { Header } from './components/Header';
import { WorkoutTemplates } from './views/WorkoutTemplates';
import { WorkoutClipboard } from './components/WorkoutClipboard/WorkoutClipboard';
import { AddTemplatesFromLibraryModal } from './components/addFromLibrary/addTemplatesFromLibraryModal';
import { SingleExercisePublishModal } from './components/SingleExercisePublishModal';
import { ExerciseTypesInfoModal } from './components/ExerciseTypesModal';
import { AutoplayedSettingsModal } from '../workout-editor/view/components/common/AutoplayedSettingsModal';
import { useWorkoutVM } from '../workout-editor/view-model/workout.viewModel';

export const workoutVM = registerContext('workoutVM', useWorkoutVM);

export const legacyEditWorkoutVM = registerContext(
  'legacyEditWorkoutVM',
  useEditWorkoutVM,
);

const EditWorkout = (data: EditWorkoutVM) => {
  return (
    <workoutVM.ValueProvider
      params={'0'}
      renderer={() => (
        <div className="flex flex-col p-6 gap-4 scroll-smooth">
          <WorkoutClipboard
            onOpen={() => data.dispatch('openClipboard')}
            paste={data.addFromClipboard}
            disabledPaste={data.isClass}
          />
          <Header
            dispatch={data.dispatch}
            control={data.control}
            currentBreadcrumb={data.currentBreadcrumb}
            watch={data.watch}
            isNewForm={data.isNewForm}
            publishAction={data.publishAction}
            readonly={data.readonly}
            errorMessage={data.errorMessage}
            newWorkoutErrors={data.newWorkoutErrors}
          />
          <WorkoutInfoForm {...data} />
          <TemplateSelection
            templates={data.templateSelection}
            control={data.control}
            disabled={data.readonly}
            observedId={data.workoutInfoId}
            dispatch={data.dispatch}
          />
          <WorkoutTemplates {...data} />
          <AddTemplatesFromLibraryModal {...data.addTemplateFromLibrary} />
          <SingleExercisePublishModal {...data.singleExercisePublishModal} />
          <ExerciseTypesInfoModal {...data.exerciseTypesInfoModal} />
          <AutoplayedSettingsModal />
        </div>
      )}
    />
  );
};

export const EditWorkoutPage = (p: {
  location: { pathname: string; query: Record<string, string> };
  routeParams: { influencerId: number; id: number };
}) => {
  const params: UseEditWorkoutVMParams = {
    influencerId: Number(p.routeParams.influencerId),
    builderType: location.pathname.includes('class') ? 'class' : 'workout',
    workoutId: Number(p.routeParams.id),
    locationQuery: p.location.query,
  };
  return (
    <legacyEditWorkoutVM.ValueProvider params={params} renderer={EditWorkout} />
  );
};
